<template>
    <div style="min-height: calc(100vh - 158px);" class="card">
        <div style="background: #DBE7F2" class="p-2">
            <TitleButton
                :showBtn="false"
                :showAddNew="false"
                title="Reconciliation Report"
            />
            <div class="row match-height mt-1">
                <div class="col-12">
                    <DateQuerySetter
                        @onClickGo="getReconciliations"
                    />
                </div>
            </div>
        </div>

        <ListTable :reconciliation-list="reconciliationList"/>
        <div class="mb-2"></div>
        <div class="px-2 position-absolute bottom-0">
            <Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>
    </div>
</template>

<script setup>
import {computed, ref, onMounted} from 'vue';
import TitleButton from '@/components/atom/TitleButton'
import ListTable from '@/components/molecule/company/reconciliation/ReconciliationListingTable.vue'
import Pagination from '@/components/atom/Pagination'
import {useRoute, useRouter} from "vue-router";
import handleReport from "@/services/modules/accountingReport";
import DateQuerySetter from "@/components/atom/DateQuerySetter.vue";

const {fetchReconciliationReport} = handleReport();
const router = useRouter()
const route = useRoute()
const offset = ref(20);

let page = ref(1);
let reconciliationList = ref({});
let companyId = computed(() => route.params.companyId);

async function getReconciliations() {
    try {
        const res = await fetchReconciliationReport(getQuery());
        if (res.status) {
            reconciliationList.value = res.data;
        }
    } catch (err) {
        if (err.response) {
            showError(err.response.message)
        }
    }
}

function getQuery() {
    const params = {
        company_id: companyId.value,
        offset: offset.value,
        start_date: route.query.start,
        end_date: route.query.end,
    }

    if (page.value) {
        params.page = page.value
    }

    const qs = new URLSearchParams(params).toString()
    return qs ? `?${qs}` : ''
}

async function onPageChange(page) {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getReconciliations();
}

onMounted(async () => {
    await getReconciliations();
})
</script>
